import React, { useState, useEffect } from 'react';
import { getRequest, postRequest, putRequest } from '../../api/index.js';
import './AvatarSettings.css';
import UserHeader from "../../components/header/UserHeader";
import UserDrawer from "../../components/drawer/UserDrawer";
import { Row, Col, notification } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import goBackButton from "../../assets/images/Go_Back.svg";
import amyImage from '../../assets/images/my-friend-logo.png';
import arthurImage from '../../assets/images/my-frieind-logo2.svg';
import samImage from '../../assets/images/Sam_Logo.png';
import { getUserBots } from '../../api/Avatar.js';

const AvatarSettings = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const [speechSpeed, setSpeechSpeed] = useState(3);
  const [voiceSpeed, setVoiceSpeed] = useState('medium');
  const location = useLocation();
  const { userId } = location.state || {};
  const [botsData, setBotsData] = useState({});

  const fetchBotsData = async () => {
    try {
      const response = await getUserBots();
      if (response.success) {
        setBotsData(response.data.reduce((acc, { botName, imageUrl }) => {
          acc[botName] = imageUrl;
          return acc;
        }, {}));
      }
    } catch (error) {
      console.error('Error fetching bot data:', error);
      notification.error({
        message: 'Error fetching bot data',
        description: error.message,
      });
    }
  };

  useEffect(() => {
    fetchBotsData();
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await getRequest('/user', userId);
        if (response.error) {
          console.error("Error fetching user data:", response.error);
        } else {
          const speedMap = {
            'x-slow': 1,
            'slow': 2,
            'medium': 3,
            'fast': 4,
            'x-fast': 5,
          };
          const speedValue = speedMap[response.voiceSpeed] || 3;
          setSpeechSpeed(speedValue);
          setVoiceSpeed(response.voiceSpeed);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  const handleGoBackButton = () => {
    navigate("/landing-page", { state: { userId } });
  };
  const sectionsContainerStyle = {
    transition: "opacity 0.3s ease, pointer-events 0.3s ease",
    opacity: isDrawerOpen ? "0.5" : "1",
    pointerEvents: isDrawerOpen ? "none" : "auto",
  };

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const [selectedVoice, setSelectedVoice] = useState('Amy');

  useEffect(() => {
    const fetchAvatar = async () => {
      try {
        const response = await getRequest('/user/get-avatar');

        if (response.error) {
          console.error("Error fetching avatar:", response.error);
          setSelectedVoice('Amy');
        } else {
          const avatar = response.avatar;

          if (avatar === 'Arthur' || avatar === 'Amy' || avatar === 'Sam') {
            setSelectedVoice(avatar);
          } else {
            setSelectedVoice('Amy');
          }
        }
      } catch (error) {
        console.error("Error fetching avatar:", error);
        setSelectedVoice('Amy');
      }
    };

    fetchAvatar();
  }, [userId]);

  const handleChooseAvatar = async (avatar) => {
    setIsLoading(true);
    const response = await postRequest('/user/choose-avatar', {
      avatar: avatar,
    });

    if (response.error) {
      notification.error({ message: 'Avatar Error', description: response.error, duration: 10 });
    } else {
      notification.success({ message: 'Avatar Success', description: 'Avatar updated successfully!', duration: 10 });
      setSelectedVoice(avatar);
    }

    setIsLoading(false);
  };

  const handleSpeedChange = async (e) => {
    const speedValue = e.target.value;
    setSpeechSpeed(speedValue);

    const speedMap = {
      '1': 'x-slow',
      '2': 'slow',
      '3': 'medium',
      '4': 'fast',
      '5': 'x-fast',
    };

    const speedLabel = speedMap[speedValue] || 'medium';
    setVoiceSpeed(speedLabel);

    try {
      const response = await putRequest('/conversation/update-voice-speed', {
        userId: userId,
        voiceSpeed: speedLabel,
      });

      if (response.error) {
        notification.error({ message: 'Voice Speed Update Error', description: response.error, duration: 10 });
      } else {
        notification.success({ message: 'Voice Speed Updated', description: 'Voice speed updated successfully!', duration: 10 });
      }
    } catch (error) {
      console.error("Error updating voice speed:", error);
      notification.error({ message: 'Voice Speed Update Error', description: error.message, duration: 10 });
    }
  };

  return (
    <div style={{ minHeight: "100dvh", background: "#fefcfe" }}>
      <Col xs={24} sm={24} lg={24} md={24} style={sectionsContainerStyle}>
        <Row
          justify={{
            xs: "space-around",
            md: "space-around",
            lg: "space-between",
          }}
          style={{ marginBottom: 20 }}
        >
          <Col xs={{ span: 22 }} lg={{ span: 24 }} md={{ span: 22 }}>
            <UserHeader setDrawer={openDrawer} />
          </Col>
          {isDrawerOpen && (
            <Col span={4}>
              <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
            </Col>
          )}
          <Col flex="10%" className="go-back-button">
            <button onClick={handleGoBackButton} className="button-styling">
              <img src={goBackButton} alt="Go Back Button" />
            </button>
          </Col>
        </Row>
        <div className="avatar-settings-container">
          <h2 className='avatar-heading'>Change Avatar Settings</h2>

          <div className="section">
            <div className="section-title">CHOOSE AVATAR</div>
            <div className="avatar-options">
              <div
                className={`avatar-option ${selectedVoice === 'Arthur' ? 'selected' : ''}`}
                onClick={() => handleChooseAvatar('Arthur')}
              >
                <div className="avatar-image">
                  <img
                    src={botsData['Arthur'] || arthurImage}
                    alt="Arthur"
                    style={{
                      borderRadius: '50%',
                      width: '54px',
                      height: '54.77px',
                    }}
                  />
                </div>
                <div className="avatar-details">
                  <h4 className='avatar-name'>Arthur</h4>
                  <p className='avatar-gender'>Male Voice</p>
                </div>
                <button
                  className={`choose-button ${selectedVoice === 'Arthur' ? 'chosen' : ''}`}
                  disabled={isLoading}
                >
                  {selectedVoice === 'Arthur' ? 'Chosen' : 'Choose'}
                </button>
              </div>

              <div
                className={`avatar-option ${selectedVoice === 'Amy' ? 'selected' : ''}`}
                onClick={() => handleChooseAvatar('Amy')}
              >
                <div className="avatar-image">
                  <img
                    src={botsData['Amy'] || amyImage}
                    alt="Amy"
                    style={{
                      borderRadius: '50%',
                      width: '54px',
                      height: '54.77px',
                    }}
                  />
                </div>
                <div className="avatar-details">
                  <h4 className='avatar-name'>Amy</h4>
                  <p className='avatar-gender'>Female Voice</p>
                </div>
                <button
                  className={`choose-button ${selectedVoice === 'Amy' ? 'chosen' : ''}`}
                  disabled={isLoading}
                >
                  {selectedVoice === 'Amy' ? 'Chosen' : 'Choose'}
                </button>
              </div>

              <div
                className={`avatar-option ${selectedVoice === 'Sam' ? 'selected' : ''}`}
                onClick={() => handleChooseAvatar('Sam')}
              >
                <div className="avatar-image">
                  <img
                    src={botsData['Sam'] || samImage}
                    alt="Sam"
                    style={{
                      borderRadius: '50%',
                      width: '54px',
                      height: '54.77px',
                    }}
                  />
                </div>
                <div className="avatar-details">
                  <h4 className='avatar-name'>Sam</h4>
                  <p className='avatar-gender'>Text Conversation</p>
                </div>
                <button
                  className={`sam_button ${selectedVoice === 'Sam' ? 'chosen' : ''}`}
                  disabled={isLoading}
                >
                  {selectedVoice === 'Sam' ? 'Chosen' : 'Choose'}
                </button>
              </div>

            </div>
          </div>

          <div className="section">
            <div className="section-title">VOICE SETTINGS</div>
            <div className="speed-control">
              <label>Speed of Speech</label>
              <input
                className="speed-slider"
                type="range"
                min="1"
                max="5"
                value={speechSpeed}
                onChange={handleSpeedChange}
              />
              <div className="speed-labels">
                <span className='speed-text very-slow'>Very Slow</span>
                <span className='speed-text very-fast'>Very Fast</span>
              </div>
            </div>
          </div>
        </div>
      </Col>
    </div>
  );
};

export default AvatarSettings;
